import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import { BsCheckCircleFill, BsCircleFill } from 'react-icons/bs'
import {
  getChecklistPDAssetResignDetailAPI,
  putChecklistResignPDAssetAPI
} from '../../../../services/checklist'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

export default function ResignsCheckListPD() {
  let [searchParams, setSearchParams] = useSearchParams()
  const [comment, setComment] = useState('')
  const [selectId, setSelectId] = useState(0)
  const [data, setData] = useState()
  const [isSave, setIsSave] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [createDate, setCreateDate] = useState([])
  const {
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver()
  })

  const dataPD = [
    {
      id: 1,
      label: 'รับคืนครบถ้วน'
    },
    {
      id: 2,
      label: 'รับคืนไม่ครบหรือสภาพเสียหาย'
    },
    {
      id: 3,
      label: 'ไม่ใช้งานคอมพิวเตอร์'
    }
  ]

  const clrNo = searchParams.get('id')

  useEffect(() => {
    setIsLoading(true)
    fnGetDetail()
  }, [clrNo])

  const fnGetDetail = async () => {
    const body = { clrNo }
    const resp = await getChecklistPDAssetResignDetailAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setCreateDate(resp.result.insert_date)

      setData(resp.result)
    } else {
      Error_false(resp)
    }
  }

  const fnSave = async () => {
    setIsSave(true)
    setIsLoading(true)
    const formData = getValues()
    const param = { clrNo }
    const body = {
      isConfirm:
        selectId === 1
          ? 1 //รับคืนครบถ้วน
          : selectId === 2
            ? 0 //รับคืนไม่ครบหรือสภาพเสียหาย
            : selectId === 3
              ? 2 //ไม่มีคอมพิวเตอร์
              : undefined,
      description: selectId === 2 ? comment : ''
    }

    const resp = await putChecklistResignPDAssetAPI(param, body)
    setIsLoading(false)
    setIsSave(false)

    if (!resp) return

    if (resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnGetDetail()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <Row className="mb- mt-3 p-3 overflow-auto">
      {isLoading && <div className="preloader"></div>}
      <div xl={12} className="mb-0 col-12">
        <div className="mt-1 mb-3">
          <span className="fw-bold me-2">เลขเอกสาร: </span>
          <span className="">{clrNo}</span>{' '}
          <span className="fw-light me-2 ">
            {createDate
              ? moment(createDate).format('DD/MM/YYYY HH:mm')
              : ''}{' '}
          </span>
        </div>

        <div className="fw-bold mb-3 mt-0 ">1. รายการทรัพย์สิน</div>
        <Table bordered size="sm">
          <thead className="bg-hrms">
            <tr>
              <th className="fw-light ">#</th>
              <th className="fw-light">Asset Tag</th>
              <th className="fw-light">Name</th>

              <th className="fw-light">Category</th>
              <th className="fw-light">Serial</th>
            </tr>
          </thead>
          <tbody>
            {data && data.asset.length > 0 ? (
              data.asset.map((d, i) => (
                <tr className="fw-light small" key={`tr-${i}`}>
                  <td>{i + 1}</td>
                  <td>{d.asset_tag}</td>
                  <td>{d.name}</td>
                  <td>{d.category}</td>
                  <td>{d.serial}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  - No data -
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="col-12">
        <div className="mb-3 ">
          <span className="fw-bold ">
            2. ตรวจสอบและเก็บคืนทรัพย์สินบริษัทฯ
          </span>{' '}
        </div>
        <CheckboxRadioCustom className="fw-light">
          {dataPD.map((d, i) => (
            <div className="form-check mb-3 " key={`${d}-${i}`}>
              {data && data.confirm_date5 === null && (
                <input
                  checked={d.id === selectId}
                  name={`description1`}
                  type="radio"
                  id={`inline-checkbox-${i}`}
                  className="form-check-input"
                  onChange={() => setSelectId(d.id)}
                />
              )}
              {data && data.confirm_date5 && (
                <>
                  {/* true false 2 */}
                  <label className="mb-2 fw-light">
                    {(data?.is_confirm5 === 1 && d.id === 1) ||
                    (data?.is_confirm5 === 0 && d.id === 2) ||
                    (data?.is_confirm5 === 2 && d.id === 3) ? (
                      <BsCheckCircleFill
                        className="me-2"
                        size={20}
                        style={{ color: '#408bff' }}
                      />
                    ) : (
                      data &&
                      data.confirm_date5 && (
                        <BsCircleFill
                          className="me-2"
                          size={20}
                          style={{ color: '#bbbbbb' }}
                        />
                      )
                    )}
                    {d.label}
                  </label>
                  {d.id === 2 && (
                    <div
                      style={{
                        marginLeft: '35px',
                        maxWidth: '400px'
                      }}
                    >
                      <BoxName className="rounded-3">
                        {data && data?.description5}
                      </BoxName>
                    </div>
                  )}
                </>
              )}

              {data && data.confirm_date5 === null && (
                <div className="form-check-label">
                  <label htmlFor={`checkbox-radio-${i}`}>{d.label}</label>

                  {d.id === 2 && (
                    <div
                      style={{
                        marginLeft: '35px',
                        maxWidth: '400px'
                      }}
                    >
                      {selectId === 2 ? (
                        <Form.Control
                          as="textarea"
                          rows={3}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </CheckboxRadioCustom>
      </div>

      <div className="col-12 d-flex justify-content-between">
        {data && data.is_confirm5 !== null ? (
          <Col xl={12} className="text-center">
            <Row>
              <Col>
                <div className=" mt-5 font-small-2 d-flex justify-content-center">
                  <div style={{ width: 300 }}>
                    <div className="d-flex justify-content-center">
                      {data && data.confirm_detail5.url5 && (
                        <Image
                          width={250}
                          fluid
                          src={data.confirm_detail5.url5}
                        />
                      )}
                    </div>
                    <div className="d-flex justify-content-center">
                      ลงชื่อ
                      <div
                        style={{
                          borderBottom: '1px dashed rgb(135, 135, 135)',
                          width: 200
                        }}
                      ></div>{' '}
                      ผู้ดำเนินการ
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      (
                      {data &&
                        `${data.confirm_detail5.title_th}${data.confirm_detail5.name_th} ${data.confirm_detail5.surname_th}`}
                      )
                    </div>
                    <div className="d-flex justify-content-center fw-light mt-1">
                      {data && data.confirm_detail5.position_th}
                    </div>
                    <div className="d-flex justify-content-center fw-light">
                      {data &&
                        data.confirm_date5 &&
                        moment(data.confirm_date5).format('DD/MM/YYYY')}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        ) : (
          <Col xl={12} className=" text-center">
            <div>
              <div className="d-flex justify-content-center">
                {data && data.confirm_date5 !== null ? (
                  <Image width={250} fluid src={data?.confirm_detail5?.url} />
                ) : (
                  <Button
                    className="px-4"
                    disabled={isSave}
                    onClick={() => {
                      if (selectId !== 0) {
                        fnSave()
                      } else {
                        SwalCustom({
                          icon: 'warning',
                          title: 'โปรดเลือกข้อมูล!',
                          text: 'กรุณาลองใหม่อีกครั้ง',
                          confirmButtonColor: ''
                        })
                      }
                    }}
                  >
                    Confirm
                  </Button>
                )}
              </div>
              <div className="d-flex justify-content-center small">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ตรวจสอบ
              </div>
              <div className="d-flex justify-content-center mt-3 small">
                (
                {data?.confirm_detail5 &&
                  `${
                    data?.confirm_detail5?.title_th
                      ? data?.confirm_detail5?.title_th
                      : '-'
                  }${
                    data?.confirm_detail5?.name_th
                      ? data?.confirm_detail5?.name_th
                      : '-'
                  } ${
                    data?.confirm_detail5?.surname_th
                      ? data?.confirm_detail5?.surname_th
                      : '-'
                  }`}
                )
              </div>
              <div className="d-flex justify-content-center small fw-light mt-1">
                {data?.confirm_detail5 && data?.confirm_detail5?.position_th}
              </div>
              <div className="d-flex justify-content-center small fw-light">
                {data?.confirm_detail5 && data?.confirm_detail5?.confirm_date3_2
                  ? moment(data?.confirm_detail5?.confirm_date3_2).format(
                      'DD/MM/YYYY'
                    )
                  : '-'}
              </div>
            </div>
          </Col>
        )}
      </div>
    </Row>
  )
}
const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: "var(--comp-badge-color-background-primary)" !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid "var(--comp-badge-color-background-primary)";
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`

const BoxName = styled.div`
  font-size: 14px;
  width: 100%;
  background-color: #e3e3e3;
  border: 1px solid #e6e6e6;
  height: 35px;
  padding: 0.375rem 0.75rem;
`
